import React, {useEffect, useState, useCallback} from 'react'
import { Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useLazyQuery} from '@apollo/client';
import _ from 'lodash';
import { useToasts } from "react-toast-notifications";
import { GET_SUMMARY_ORDER } from '../../graphql/totalSummary/query';

const SummaryOrder = ({systems, pages, date, setIsLoading}) => {
    const { addToast } = useToasts();
    const [tableData, setTableData] = useState([]);
    //* Query ***
    const [getSummaryOrder, { data: summaryOrderData, loading: loadingSummaryOrder }] = useLazyQuery(GET_SUMMARY_ORDER, {
        fetchPolicy: 'cache-and-network',
    });

    //* useEffect ***
    useEffect(() => {
        if(!_.isEmpty(systems?.amount)|| !_.isEmpty(pages?.amount) || !_.isEmpty(date.createdAt_lt)) {
            setTimeout(() => {
                handleSummaryOrder();
            }, 1000);
        }
    }, [systems, pages, date]);

    useEffect(() => {
        if(!_.isEmpty(summaryOrderData)) {
            const summaryOrder = summaryOrderData?.getSummaryOrder;
            const newSummaryOrder = JSON.parse(summaryOrder);
            if(newSummaryOrder.length > 0) {
                setTableData(newSummaryOrder);
            }
        }
    }, [summaryOrderData]);

    useEffect(() => {
        if(loadingSummaryOrder) setIsLoading((prev) => ({...prev, loadingSummaryOrder: true}));
    }, [loadingSummaryOrder]);
    

    //* Function ****
    const handleSummaryOrder = async () => {
        if (loadingSummaryOrder) return;
        try {
            let where = {}
            if(!_.isEmpty(systems?.listName)) where = {...where, systems: systems?.listName.split(', ')};
            if(!_.isEmpty(pages?.listId)) where = {...where, pages: pages?.listId.split(', ')};
            if(!_.isEmpty(date?.createdAt_gte) && !_.isEmpty(date?.createdAt_lt)) {
                where = {...where, 
                    createdAt_gte: date?.createdAt_gte,
                    createdAt_lt: date?.createdAt_lt
                };
            }

            setTableData([]);
            await getSummaryOrder({variables: { where }});
            setIsLoading((prev) => ({...prev, loadingSummaryOrder: false}));
        } catch (error) {
            setTableData([]);
            setIsLoading((prev) => ({...prev, loadingSummaryOrder: false}));
            console.log("handleSummaryOrder error: ", error);
            if (error.message){
                console.log("1 handleSummaryOrder error: ", error.message);
                addToast("ບໍ່ພົບຂໍມູນ", {
                    appearance: "warning",
                    autoDismiss: true,
                });
            } else{
                console.log("2 handleSummaryOrder error: ", error.message);
                addToast("ມີຂໍຜີດຜາດທີ່ບໍ່ຄາດຄີດສຳລັບ ຍອດເງີນ", {
                    appearance: "error",
                    autoDismiss: true,
                });
            }
        }
    }
    // Data structure for the table
    // const tableData = [
    //     {
    //         label: 'ທັງຫມົດ',
    //         total: '100',
    //         Live: '50',
    //         Post: '50',
    //         POS: '0',
    //         SalePage: '0',
    //         byShop: '0'
    //     },
    //     {
    //         label: 'ຍັງບໍ່ຊຳລະ',
    //         total: '50',
    //         Live: '0',
    //         Post: '50',
    //         POS: '0',
    //         SalePage: '0',
    //         byShop: '0'
    //     },
    //     {
    //         label: 'ລໍຖ້າຢືນຢັ້ນ',
    //         total: '25',
    //         Live: '25',
    //         Post: '0',
    //         POS: '0',
    //         SalePage: '0',
    //         byShop: '0'
    //     },
    //     {
    //         label: 'ຊຳລະແລ້ວ',
    //         total: '25',
    //         Live: '25',
    //         Post: '0',
    //         POS: '0',
    //         SalePage: '0',
    //         byShop: '0'
    //     },
    //     {
    //         label: 'ຂົນສົ່ງ',
    //         total: '25',
    //         Live: '25',
    //         Post: '0',
    //         POS: '0',
    //         SalePage: '0',
    //         byShop: '0'
    //     },
    //     {
    //         label: 'ຂົນສົ່ງສຳເລັດ',
    //         total: '0',
    //         Live: '0',
    //         Post: '0',
    //         POS: '0',
    //         SalePage: '0',
    //         byShop: '0'
    //     }
    // ];

    return (
        <Table responsive striped bordered hover>
            <thead className="bg-light">
            <tr>
                <th style={{ minWidth: '120px', color: '#0d6efd'}}></th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>ທັງຫມົດ</th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>Live</th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>Post</th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>POS</th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>Sale Page</th>
                <th style={{ minWidth: '120px', color: '#0d6efd' }}>ສ້າງເອງ</th>
            </tr>
            </thead>
            <tbody>
            {_.isEmpty(tableData) ? (
                <tr>
                    <td colSpan={7} className="text-center">
                    {loadingSummaryOrder ? 'ກໍາລັງໂຫຼດ...' : 'ບໍ່ພົບຂໍ້ມູນ'}
                    </td>
                </tr>
            ) : (
                tableData.map((row, index) => (
                <tr key={index}>
                    <td style={{ color: '#0d6efd' }}>{row?.label}</td>
                    <td>{row?.total.toLocaleString('en-US')}</td>
                    <td>{row?.Live.toLocaleString('en-US')}</td>
                    <td>{row?.Post.toLocaleString('en-US')}</td>
                    <td>{row?.POS.toLocaleString('en-US')}</td>
                    <td>{row?.SalePage.toLocaleString('en-US')}</td>
                    <td>{row?.byShop.toLocaleString('en-US')}</td>
                </tr>
            )))}
            </tbody>
        </Table>
    );
}

export default SummaryOrder